import React from 'react';

interface RarExtProps {
    width?: number;
    height?: number;
}

export const RarExt = ({ height = 26, width = 26 }: RarExtProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 26 26"
        fill="none"
    >
        <g clipPath="url(#clip0_5885_18355)">
            <path
                d="M23.3269 5.11064L18.4519 0.235638C18.376 0.160337 18.2859 0.100762 18.1869 0.0603282C18.0879 0.0198946 17.9819 -0.000601989 17.875 1.34596e-05H4.875C3.52879 1.34596e-05 2.4375 1.0913 2.4375 2.43751V23.5625C2.4375 24.9087 3.52879 26 4.875 26H21.125C22.4712 26 23.5625 24.9087 23.5625 23.5625V5.68751C23.5631 5.58058 23.5426 5.47458 23.5022 5.37559C23.4618 5.27659 23.4022 5.18656 23.3269 5.11064ZM21.9375 23.5625C21.9375 24.0113 21.5738 24.375 21.125 24.375H4.875C4.42625 24.375 4.0625 24.0113 4.0625 23.5625V2.43751C4.0625 1.98876 4.42625 1.62501 4.875 1.62501H17.0625V4.87501C17.0625 5.77247 17.79 6.50001 18.6875 6.50001H21.9375V23.5625Z"
                fill="#D7D7D7"
            />
            <path
                d="M20 21.1667C20 21.625 19.625 22 19.1667 22H0.833333C0.375 22 0 21.625 0 21.1667V12.8333C0 12.375 0.375 12 0.833333 12H19.1667C19.625 12 20 12.375 20 12.8333V21.1667Z"
                fill="#9035A5"
            />
            <path
                d="M12.5603 14.5234H14.2727C14.6487 14.5234 14.9677 14.5804 15.2298 14.6943C15.4941 14.8083 15.6957 14.9769 15.8347 15.2002C15.9737 15.4212 16.0432 15.6947 16.0432 16.0205C16.0432 16.2598 15.9977 16.474 15.9065 16.6631C15.8154 16.8499 15.6855 17.0083 15.5169 17.1382C15.3483 17.2681 15.1466 17.3672 14.9119 17.4355L14.6863 17.5381H13.1175L13.1106 16.9194H14.2898C14.5086 16.9194 14.6897 16.8807 14.8333 16.8032C14.9791 16.7257 15.0885 16.6209 15.1614 16.4888C15.2366 16.3566 15.2742 16.2074 15.2742 16.041C15.2742 15.861 15.2389 15.7038 15.1682 15.5693C15.0976 15.4326 14.9882 15.3278 14.8401 15.2549C14.692 15.182 14.5029 15.1455 14.2727 15.1455H13.3328V19.5H12.5603V14.5234ZM15.4314 19.5L14.242 17.2544L15.052 17.251L16.2552 19.4556V19.5H15.4314Z"
                fill="white"
            />
            <path
                d="M10.1299 15.0908L8.57471 19.5H7.77148L9.65479 14.5234H10.1675L10.1299 15.0908ZM11.4321 19.5L9.87354 15.0908L9.83252 14.5234H10.3486L12.2388 19.5H11.4321ZM11.3535 17.6543V18.2764H8.60889V17.6543H11.3535Z"
                fill="white"
            />
            <path
                d="M4.14474 14.5234H5.85715C6.23312 14.5234 6.55213 14.5804 6.81418 14.6943C7.0785 14.8083 7.28016 14.9769 7.41916 15.2002C7.55816 15.4212 7.62766 15.6947 7.62766 16.0205C7.62766 16.2598 7.58208 16.474 7.49094 16.6631C7.39979 16.8499 7.26991 17.0083 7.10129 17.1382C6.93267 17.2681 6.73101 17.3672 6.49631 17.4355L6.27072 17.5381H4.70187L4.69504 16.9194H5.87424C6.09299 16.9194 6.27414 16.8807 6.41769 16.8032C6.56353 16.7257 6.6729 16.6209 6.74582 16.4888C6.82101 16.3566 6.85861 16.2074 6.85861 16.041C6.85861 15.861 6.82329 15.7038 6.75266 15.5693C6.68202 15.4326 6.57264 15.3278 6.42453 15.2549C6.27642 15.182 6.08729 15.1455 5.85715 15.1455H4.91721V19.5H4.14474V14.5234ZM7.01584 19.5L5.82639 17.2544L6.63644 17.251L7.83957 19.4556V19.5H7.01584Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_5885_18355">
                <rect width="26" height="26" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
